import { useFpB2bButlerItemsService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-butler-items-service'
import { useFpB2bButlerService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-butler-service'
import { useApiOrderItems } from '@hooks-api/butler/useApiOrderItems'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { AiAnalysisError } from '../AiAnalysisError/AiAnalysisError'
import { AiAnalyzing } from '../AiAnalyzing/AiAnalyzing'
import { AiInputProcessor, type AiInputProcessorProps } from '../AiInputProcessor/AiInputProcessor'
import { useButler } from '../ButlerProvider/useButler'

export type AiPurchaseOrderContentProps = AiInputProcessorProps

export const AiPurchaseOrderContent = (props: AiPurchaseOrderContentProps) => {
  const history = useHistory()
  const { campaignId, platform, routes } = useButler()
  const { isOrderStatusInProgress, isOrderStatusCompleted, isGetOrderStatusFailed, isOrderStatusIncorrectFormat, errors, orderId } = useFpB2bButlerService(campaignId, platform)
  const { upsertButlerItem, items: ButlerItems } = useFpB2bButlerItemsService(campaignId, platform)

  useApiOrderItems(isOrderStatusCompleted ? orderId : null,
    {
      onSuccess: (data) => {
        const items = data.data.data.items
        if (!items.length) return
        if (ButlerItems.some(item => !!item.recommendations)) return // 如果有商品已經有推薦過，就不再重新推薦
        items.forEach((item) => {
          if (!item.orderItemId) return
          upsertButlerItem({
            cartItemId: item.orderItemId,
            checked: true,
            isDeleted: false,
            ...item,
          })
        })
      },
    },
  )

  useEffect(function redirectToRecommendationsOnce() {
    // 使用 orderId 作為 key，確保每個訂單只導向一次
    const redirectKey = `ai-order-redirected-${orderId}`
    const hasRedirected = sessionStorage.getItem(redirectKey)
    if (isOrderStatusCompleted && !hasRedirected) {
      sessionStorage.setItem(redirectKey, 'true')
      history.push(routes.recommendations)
    }
  }, [isOrderStatusCompleted, orderId, history, routes.recommendations])

  if (isOrderStatusInProgress) {
    return <AiAnalyzing />
  }
  const hasErrors = Object.keys(errors).length > 0
  if (hasErrors || isGetOrderStatusFailed || isOrderStatusIncorrectFormat) {
    return <AiAnalysisError />
  }
  return <AiInputProcessor {...props} />
}
